// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class HelloMessage extends PFixMessage {
    constructor(fieldSet) {
        super(Message.CODE_PFIX_HELLO_MESSAGE, fieldSet);
    }
    setHello(hello) {
        this.setFieldValue(FieldsFactory.FIELD_PASSWORD, hello);
    }
    getHello() {
        return this.getFieldValue(FieldsFactory.FIELD_PASSWORD);
    }
    EncryptionType() {
        const field = this.getFieldValue(FieldsFactory.FIELD_ID);
        return field !== null ? field : 0;
    }
    // +++ new
    getMaxFieldNumber() {
        const FIELD_MAX_PFIX_FIELD_INDEX = this.FieldSet.GetField(FieldsFactory.FIELD_MAX_PFIX_FIELD_INDEX);
        if (FIELD_MAX_PFIX_FIELD_INDEX) {
            return FIELD_MAX_PFIX_FIELD_INDEX.Value;
        }
        else {
            return 2147483647;
        } // int.MaxValue;
    }
    // +++ new
    setMaxFieldNumber(number) {
        this.setFieldValue(FieldsFactory.FIELD_MAX_PFIX_FIELD_INDEX, number);
    }
    // +++ new
    getProtocolVersion() {
        return this.getFieldValue(FieldsFactory.FIELD_PROTOCOL_ID);
    }
    // +++ new
    setProtocolVersion(version) {
        this.setFieldValue(FieldsFactory.FIELD_PROTOCOL_ID, version);
    }
}
